<template>

    <div style="max-width: 400px;">

        <audio controls v-if="file.url">
            <source :src="file.url">
            {{ t.__('Twoja przeglądarka nie wspiera elementów audio.') }}
        </audio>

        <input type="hidden"
               :name="inputName"
               v-if="file.url"
               v-model="file">

        <div>
            <a href="javascript:void(0)" class="btn btn-sm btn-primary" @click="showFileManager()">
                <span v-if="file.url === null">{{ t.__('Wybierz') }}</span>
                <span v-if="file.url !== null">{{ t.__('Zmień') }}</span>
            </a>
            <a href="javascript:void(0)" class="btn btn-sm btn-danger" v-if="file.url !== null" @click="clear()">{{ t.__('Usuń') }}</a>
        </div>

        <div class="hint-text" v-if="!hideHints && (hint || additionalHint !== '')">
            <div v-if="hint">{{ hint }}</div>
            <div v-if="additionalHint">{{ additionalHint }}</div>
        </div>

    </div>

</template>

<script>
    import File from "./classes/File";
    import mime from "mime";

    export default {
        props: {
            inputName: {
                type: String,
                default: null
            },
            value: {
                type: File,
                default: null
            },
            mimeTypes: {
                type: String,
                default: null
            },
            additionalHint: {
                type: String,
                default: ''
            },
            hideHints: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                eventHub: window.eventHub,
                file: this.value,
                hint: null
            }
        },
        model: {
            event: 'change'
        },
        methods: {
            showFileManager() {
                this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes)
            },
            clear() {
                this.file.reset();
                this.$emit('change', this.file);
            },
            getNameFromUrl(url) {
                return url.substring(url.lastIndexOf('/')+1);
            }
        },
        beforeMount() {
            if (this.file == null) {
                this.file = new File();
            }

            const allowedExtensions = this.mimeTypes.split(',')
                .map(mimeType => Array.from(mime.getAllExtensions(mimeType)))
                .flat();
            if (allowedExtensions.length) {
                this.hint = t.__('Dozwolone rozszerzenia: ') + allowedExtensions.join(', ') + '.'
            }
        },
        mounted() {
            this.eventHub.$on('file-manager-selected-' + this._uid, (file) => {
                this.file.selectFromLibrary(file);
                this.$emit('change', this.file);
                this.eventHub.$emit('hide-file-manager');
            });
        }
    };
</script>

<style scoped>

.btn-sm {
    padding: 0.25rem 0.5rem;
}

.hint-text {
    font-size: 12px;
    color: white;
    margin-top: 5px;
}

</style>
